/**
 * Notificações que a pessoa já viu (abriu o sino com elas na lista). Sem
 * backend: por pessoa, no armazenamento local do navegador; sem ele (modo
 * privado, bloqueio), só na memória desta aba.
 */
const memory = new Map<string, string[]>();

/** Teto de segurança: a lista guardada é a do sino, que já é curta. */
export const SEEN_NOTIFICATIONS_LIMIT = 200;

const storageKey = (userUid: string) =>
  `ops-panel:notificacoes-vistas:${userUid}`;

export const readSeenNotifications = (userUid: string): Set<string> => {
  const key = storageKey(userUid);
  let raw: string | null;
  try {
    raw = window.localStorage.getItem(key);
  } catch (error) {
    // Sem armazenamento: vale a memória
    return new Set(memory.get(key) || []);
  }
  try {
    const parsed = raw ? JSON.parse(raw) : [];
    return new Set(
      Array.isArray(parsed)
        ? parsed.filter((id): id is string => typeof id === 'string')
        : []
    );
  } catch (error) {
    // Valor estragado: nada visto
    return new Set();
  }
};

/**
 * Marca como vistas as notificações que estão na lista agora. As que saíram
 * dela não ficam guardadas: a lista não cresce sem fim e um item que muda
 * ganha outro id.
 */
export const saveSeenNotifications = (
  userUid: string,
  ids: string[]
): Set<string> => {
  const key = storageKey(userUid);
  const next = Array.from(new Set(ids)).slice(0, SEEN_NOTIFICATIONS_LIMIT);
  memory.set(key, next);
  try {
    window.localStorage.setItem(key, JSON.stringify(next));
  } catch (error) {
    // Sem armazenamento: fica a memória
  }
  return new Set(next);
};
